import * as appConstant from "../Constants/appConstants";

export const getColorFromStatus = (value) => {
  let color = "";
  if (value === null) return color;
  switch (value.toUpperCase()) {
    case appConstant.ACTIVE:
    case "PROCESSED":
    case "SUCCESS":
      color = "success";
      break;
    case appConstant.INACTIVE:
      color = "fail";
      break;
    case appConstant.PENDING:
    case appConstant.HOLD:
      color = "primary";
      break;
    case appConstant.REJECTED:
      color = "fail";
      break;
    default:
      color = "var(--counselor)";
      break;
  }

  return color;
};

export const getColorFromIPD = (value) => {
  let color = "";

  if (value === null) {
    color = "success";
  } else {
    color = "secondary";
  }
  return color;
};

export const getColorOfStatus = (value) => {
  let color = "";

  switch (value) {
    case appConstant.PENDING:
      color = "primary";
      break;
    case appConstant.CLOSED:
      color = "fail";
      break;
    case appConstant.CANCELLED:
      color = "fail";
      break;
    case appConstant.AT_DOCTOR:
      color = "doctor";
      break;
    case appConstant.COMPLETED:
      color = "success";
      break;
    case appConstant.SETTLED:
      color = "success";
      break;
    case appConstant.OPEN:
      color = "primary";
      break;
    case appConstant.AT_COUNSELLOR:
      color = "primary";
      break;
    case appConstant.AT_PHARMACY:
      color = "secondary";
      break;
    default:
      color = "primary";
      break;
  }

  return color;
};

export const getStatusTextColor = (status) => {
  switch (status) {
    case appConstant.PENDING:
    case appConstant.OPEN:
    case appConstant.AT_COUNSELLOR:
      return "var(--counselor)"; // matches .status__primary

    case appConstant.AT_PHARMACY:
      return "var(--yellow)"; // matches .status__secondary

    case appConstant.COMPLETED:
    case appConstant.SETTLED:
      return "var(--success)"; // matches .status__success

    case appConstant.CANCELLED:
    case appConstant.CLOSED:
      return "var(--fail)"; // matches .status__fail

    case appConstant.AT_DOCTOR:
      return "var(--doctor)"; // matches .status__doctor

    default:
      return "#333"; // fallback text color
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case appConstant.PENDING:
    case appConstant.OPEN:
    case appConstant.AT_COUNSELLOR:
      return "rgba(239, 242, 254, 1)"; // matches var(--list-hover) — light blue background

    case appConstant.AT_DOCTOR:
      return "var(--doctor-bg)"; // e.g., #8f6ea3

    case appConstant.AT_PHARMACY:
      return "var(--light-yellow)"; // match your theme variable

    case appConstant.COMPLETED:
    case appConstant.SETTLED:
      return "var(--success-bg)"; // e.g., #f2fdf7

    case appConstant.CANCELLED:
    case appConstant.CLOSED:
      return "var(--fail-bg)"; // e.g., #fef0f1

    default:
      return "var(--list-hover)"; // fallback (primary)
  }
};

export const getColorOfOxygen = (value) => {
  let color = "";

  switch (value) {
    case appConstant.AVAILABLE:
      color = "success";
      break;
    case appConstant.NOT_AVAILABLE:
      color = "secondary";
      break;
    case appConstant.RESERVED:
      color = "reserved";
      break;
    case appConstant.UNDER_MAINTENANCE:
      color = "fail";
      break;
    case appConstant.ENABLE:
      color = "success";
      break;
    case appConstant.DISABLE:
      color = "pending";
      break;
    case appConstant.OCCUPIED:
      color = "occupied";
      break;
    default:
      color = "var(--counselor)";
      break;
  }

  return color;
};
export const getPaymentColor = (value = "") => {
  switch (value.toUpperCase()) {
    case "PENDING":
      return "fail";
    case "CASH":
      return "success";
    case "UPI":
      return "success";
    case "CARD":
      return "success";
    case "ONLINE":
      return "success";
    default:
      return "default"; // fallback or grey
  }
};
